import { removeTrendParams } from "../components/AssetManagement/Overview/Trends/TrendsMobile/helpers/funcs/filterURLRemove";
import {
  removeParamsFromList,
  timeUnitParams,
} from "../components/AssetManagement/Overview/Trends/TrendsMobile/helpers/funcs/timeUnitParams";
import {
  clearFilterMobileDataMap,
  resetMobileFilters,
  setNotesLabelFilter,
  setTrendsMobileData,
} from "../features/trendsSlice";

export const resetOnWorkspaceChange = ({
  dispatch,
  searchParams,
}: {
  dispatch: any;
  searchParams: URLSearchParams;
}) => {
  // 🔹 Redux resets
  dispatch(setTrendsMobileData(null));
  dispatch(resetMobileFilters());
  dispatch(setNotesLabelFilter(null));
  dispatch(clearFilterMobileDataMap());

  // 🔹 URL cleanup
  let updated = removeTrendParams(searchParams);
  updated = removeParamsFromList(updated, timeUnitParams);

  return updated;
};
